import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Accordion, Box, Copy } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import PaymentCalculator from '../../PaymentCalculator';
import themeStyles from './styles/BAPTrimPayment.styles';
import useSyncBAPStateToURL from '../../ConfigureBap/hooks/useSyncBAPStateToURL';
import { defaultDraftCalculatorId, hydrateFromCalculator, persistCalculatorToUrl, primaryCalculatorId, } from '../../../core/reducers/financialCalculators';
import { setShowRecommendedWarrantyChangedToast } from '../../../core/reducers/ui';
import { useAppDispatch } from '../../../core/utils';
const AccordionTitle = themeStyles.apply(Copy, 'AccordionTitle');
const AccordionWrapper = themeStyles.apply(Box, 'AccordionWrapper');
const BAPTrimPayment = () => {
    useSyncBAPStateToURL();
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const calculatorAccordionItem = [
        {
            key: 'paymentCalculator',
            title: (_jsx(AccordionTitle, { size: "subheading", "data-testid": "payment-calculator-accordion-title", children: t('Pages.Bap.paymentOptionsLabel') })),
            content: (_jsx(Box, { "data-testid": "payment-calculator-accordion-content", children: _jsx(PaymentCalculator, { id: primaryCalculatorId, showPriceBreakdown: true, onPaymentOptionsChanged: () => {
                        dispatch(persistCalculatorToUrl(primaryCalculatorId));
                        dispatch(hydrateFromCalculator({ sourceId: primaryCalculatorId, destinationId: defaultDraftCalculatorId }));
                        dispatch(setShowRecommendedWarrantyChangedToast(true));
                    }, hasAccordionPadding: true }) })),
        },
    ];
    return (_jsx(AccordionWrapper, { "data-testid": "payment-calculator-accordion", children: _jsx(Accordion, { borderColor: "grey.2", itemsHaveTopBorder: false, hideBorderOnLastItem: false, activeTitleHasBorder: true, items: calculatorAccordionItem, defaultActiveItems: ['paymentCalculator'], overrideAccessibility: true }) }));
};
export default BAPTrimPayment;
